import { ApiProperty } from "@nestjs/swagger";

export class VendorDto {
    id: number
    vendorName : string;
        vendroType : string;
        vendorCode: string;
        contactPerson : string;
        phoneNumber : string;
        address : string;
        createdUser : string;
        isActive : boolean;
        versionFlag : number;
        updatedUser : string;
        gstNumber : string;
    constructor(id: number,
        vendorName : string,
        vendorCode: string,
        vendroType : string,
        contactPerson : string,
        phoneNumber : string,
        address : string,
        createdUser : string,
        isActive : boolean,
        versionFlag : number,
        updatedUser : string,gstNumber : string){
            this.id = id;
            this.vendorName =vendorName;
            this.vendorCode = vendorCode;
            this.vendroType =vendroType;
            this.contactPerson =contactPerson;
            this.phoneNumber =phoneNumber;
            this.address =address;
            this.createdUser =createdUser;
            this.isActive =isActive;
            this.versionFlag =versionFlag;
            this.updatedUser =updatedUser;
            this.gstNumber =gstNumber;
        }

}